var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFasttag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_191_779)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_191_779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 4.99746V7.01413C18.9999 8.3308 18.1665 9.16413 16.8499 9.16413H13.9999V3.33913C13.9999 2.41413 14.7582 1.6558 15.6832 1.66413C16.5915 1.67246 17.4249 2.03913 18.0249 2.63913C18.6249 3.24746 18.9999 4.0808 18.9999 4.99746Z",
    fill: "#1D453F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2.33337 5.83073V17.4974C2.33337 18.1891 3.1167 18.5807 3.6667 18.1641L5.0917 17.0974C5.42503 16.8474 5.8917 16.8807 6.1917 17.1807L7.57503 18.5724C7.90003 18.8974 8.43337 18.8974 8.75837 18.5724L10.1584 17.1724C10.45 16.8807 10.9167 16.8474 11.2417 17.0974L12.6667 18.1641C13.2167 18.5724 14 18.1807 14 17.4974V3.33073C14 2.41406 14.75 1.66406 15.6667 1.66406H6.50003H5.6667C3.1667 1.66406 2.33337 3.15573 2.33337 4.9974V5.83073Z",
    fill: "#1D453F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6664 10.2109H8.16638C7.82471 10.2109 7.54138 10.4943 7.54138 10.8359C7.54138 11.1776 7.82471 11.4609 8.16638 11.4609H10.6664C11.008 11.4609 11.2914 11.1776 11.2914 10.8359C11.2914 10.4943 11.008 10.2109 10.6664 10.2109Z",
    fill: "#1D453F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16638 8.13281H10.6664C11.008 8.13281 11.2914 7.84948 11.2914 7.50781C11.2914 7.16615 11.008 6.88281 10.6664 6.88281H8.16638C7.82471 6.88281 7.54138 7.16615 7.54138 7.50781C7.54138 7.84948 7.82471 8.13281 8.16638 8.13281Z",
    fill: "#1D453F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64131 6.67188C5.17464 6.67188 4.80798 7.04687 4.80798 7.50521C4.80798 7.96354 5.18298 8.33854 5.64131 8.33854C6.09964 8.33854 6.47464 7.96354 6.47464 7.50521C6.47464 7.04687 6.09964 6.67188 5.64131 6.67188Z",
    fill: "#1D453F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.64108 10.0078C5.17441 10.0078 4.80774 10.3828 4.80774 10.8411C4.80774 11.2995 5.18274 11.6745 5.64108 11.6745C6.09941 11.6745 6.47441 11.2995 6.47441 10.8411C6.47441 10.3828 6.09941 10.0078 5.64108 10.0078Z",
    fill: "#1D453F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_191_779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.666626)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_191_779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.666626)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFasttag);
export default __webpack_public_path__ + "static/media/fasttag.a0e122b60b9b5e01aa27e3dd0ee5ecda.svg";
export { ForwardRef as ReactComponent };